import React, {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {I18nProvider} from 'i18n/I18nContext'
import {pathSegments} from 'i18n/localePaths'
import {
  isAppLocale,
  readCachedLocale,
  resolveInitialLocale,
  writeCachedLocale,
  type AppLocale,
} from 'i18n/locales'

/**
 * Resolves the UI locale from the first URL segment (e.g. /en/...) and wraps children in
 * `I18nProvider`. Use as a child of `BrowserRouter` so `useLocation` and cookies/cache match the page.
 */
export function I18nFromUrlProvider(props: {children: React.ReactNode}) {
  const {pathname} = useLocation()
  const segs = pathSegments(pathname)
  const fromPath =
    segs[0] && isAppLocale(segs[0]) ? (segs[0] as AppLocale) : null
  const locale = fromPath ?? readCachedLocale() ?? resolveInitialLocale()

  useEffect(() => {
    if (fromPath) writeCachedLocale(fromPath)
  }, [fromPath])

  return <I18nProvider locale={locale}>{props.children}</I18nProvider>
}
